import { useContext } from 'react'
import { AppViewsContext } from '.'

export const useAppViews = () => {
  const appViewsContext = useContext(AppViewsContext)
  return appViewsContext
}
